import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
} from '@material-ui/core';
import * as events from '../../../events';

import styles from './styles.module.css';
import LoginMessageSnackbar from './LoginMessageSnackbar';

const messages = defineMessages({
  FORGOT_LOGIN_NAME: {
    id: 'FORGOT_LOGIN_NAME',
    defaultMessage: 'Forgot Login Name',
  },
  FORGOT_LOGIN_HELPTEXT: {
    id: 'FORGOT_LOGIN_HELPTEXT',
    // eslint-disable-next-line max-len
    defaultMessage: 'Please provide the email and user extension linked to your account so we can email you your Login Name.',
  },
  SEND: {
    id: 'SEND',
    defaultMessage: 'Send',
  },
  FORGOT_PASSWORD: {
    id: 'FORGOT_PASSWORD',
    defaultMessage: 'Forgot password',
  },
  BACK_TO_LOGIN: {
    id: 'BACK_TO_LOGIN',
    defaultMessage: 'Back to login',
  },
  EMAIL: {
    id: 'EMAIL',
    defaultMessage: 'Email',
  },
  EMAIL_REQUIRED: {
    id: 'EMAIL_REQUIRED',
    defaultMessage: 'Email required',
  },
  EXTENSION_OPTIONAL: {
    id: 'EXTENSION_OPTIONAL',
    defaultMessage: 'Extension (Optional)',
  },
});

function ForgotLogin({ intl }) {
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [extension, setExtension] = useState('');
  const [reqAttempted, setReqAttempted] = useState(false);

  const onEmailChange = (e) => {
    setEmail(e.target.value);

    if (!e.target.value) {
      setEmailErr(intl.formatMessage({ ...messages.EMAIL_REQUIRED }));
    } else {
      setEmailErr('');
    }
  };

  const onExtensionChange = (e) => {
    setExtension(e.target.value);
  };

  const forgotLoginSubmit = (e) => {
    e.preventDefault();

    setReqAttempted(true);

    if (!email) {
      setEmailErr(intl.formatMessage({ ...messages.EMAIL_REQUIRED }));
    } else {
      dispatch(events.forgotLogin(email, extension));
    }
  };

  const resetForm = () => {
    setReqAttempted(false);
  };

  return (
    <div className={`${styles.loginCard} animate__animated animate__fadeIn`}>
      <Card className={styles.card} style={{ textAlign: 'left' }}>
        <CardHeader style={{ paddingLeft: 32 }} title={intl.formatMessage({ ...messages.FORGOT_LOGIN_NAME })} />

        <CardContent className={styles.content} classes={{ root: styles.loginFormCard }}>
          <div style={{ color: '#333', paddingLeft: 16 }}>
            <FormattedMessage {...messages.FORGOT_LOGIN_HELPTEXT} />
          </div>

          <form onSubmit={forgotLoginSubmit} noValidate style={{ marginTop: 7 }}>
            <TextField
              required
              id="email"
              type="text"
              onFocus={resetForm}
              onBlur={onEmailChange}
              onChange={onEmailChange}
              className={styles.textField}
              label={intl.formatMessage({ ...messages.EMAIL })}
              error={reqAttempted && Boolean(emailErr)}
            />
            <TextField
              id="extension"
              type="text"
              onFocus={resetForm}
              className={styles.textField}
              onBlur={onExtensionChange}
              onChange={onExtensionChange}
              label={intl.formatMessage({ ...messages.EXTENSION_OPTIONAL })}
            />
            <Button
              fullWidth
              size="large"
              type="submit"
              color="primary"
              variant="contained"
              className={styles.loginBtn}
            >
              <FormattedMessage {...messages.SEND} />
            </Button>
          </form>
        </CardContent>
      </Card>

      <LoginMessageSnackbar />

    </div>
  );
}

export default injectIntl(ForgotLogin);
